export default __webpack_public_path__ + "static/media/kitchen5-afterA-1440w.b1c30cfd.webp";